import React, { useState, useEffect } from 'react';
import ProjectCard from './ProjectCard.js';
import CustomRadioButtons from './NewRadioButtons'; // Import the new CustomRadioButtons component

const projectData = [
  {
    category: 'Web Development',
    imageSrc: './card1.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'Travel planning website',
    description: 'Developed a dynamic travel planning website that allows users to create personalized travel itineraries by inputting details . Designed an intuitive user interface to enhance user experience and implemented robust backend functionality to store and manage user-generated travel plans efficiently.',
    buttonLink: 'https://drive.google.com/file/d/1zGbsRBfmGHUlLPQQ1ZVspKm98uGdZeQm/view?usp=share_link',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/Travel-planning-website',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=20909&format=png&color=000000', alt: 'HTML Logo', label: 'React' },
      { src: 'https://img.icons8.com/?size=100&id=21278&format=png&color=000000', alt: 'TypeScript Logo', label: 'TypeScript' },
      { src: 'https://img.icons8.com/?size=100&id=108784&format=png&color=000000', alt: 'Three.js Logo', label: 'Three.js' },
      { src: 'https://img.icons8.com/?size=100&id=UFXRpPFebwa2&format=png&color=000000', alt: 'Redux Logo', label: 'Redux' },
      { src: 'https://img.icons8.com/?size=100&id=fAMVO_fuoOuC&format=png&color=000000', alt: 'Firebase Logo', label: 'Firebase' },
    ],
  },
  {
    category: 'Web Development',
    imageSrc: './card2.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'Real Time Chat App',
    description: 'A real-time chat application that enables users to exchange instant messages and monitor online statuses through a seamless, responsive interface. It incorporates secure user authentication, ensures reliable conversation flow, and implements comprehensive error handling on both client and server sides.',
    buttonLink: 'https://drive.google.com/file/d/10ORFrWInujnT2ujBJVkKsVp4shRKj2xN/view?usp=sharing',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/Real-time-chat-app',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=asWSSTBrDlTW&format=png&color=000000', alt: 'ReactJS Logo', label: 'ReactJS' },
      { src: 'https://img.icons8.com/?size=100&id=4PiNHtUJVbLs&format=png&color=000000', alt: 'Tailwind Logo', label: 'Tailwind' },
      { src: 'https://img.icons8.com/?size=100&id=54087&format=png&color=000000', alt: 'NodeJS Logo', label: 'NodeJS' },
      { src: 'https://img.icons8.com/?size=100&id=bosfpvRzNOG8&format=png&color=000000', alt: 'MongoDB Logo', label: 'MongoDB' },
    ],
  },
  {
    category: 'Web Development',
    imageSrc: './card8.png',
    imageClass: 'project-img-placeholder',
    title: 'SmartSpendAI - Expense Tracker AI',
    description: 'An expense tracker that leverages artificial intelligence to help users manage their finances effectively. It provides AI-powered insights into spending patterns, automates expense categorization, and offers a smart dashboard for visualizing financial data, empowering users to achieve their financial goals with ease.',
    buttonLink: 'https://drive.google.com/file/d/1yhu5AIC1xlKfqWd109UN6wzEaxrVRjGc/view?usp=sharing',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/AI_Expense_Tracker_Website',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=yUdJlcKanVbh&format=png&color=000000', alt: 'NextJS Logo', label: 'NextJS' },
      { src: "https://img.icons8.com/color/48/typescript.png", alt: '=typescript Logo', label: 'Typescript' },
      { src: 'https://img.icons8.com/?size=100&id=4PiNHtUJVbLs&format=png&color=000000', alt: 'Tailwind Logo', label: 'Tailwind' },
      { src: "https://img.icons8.com/color/48/postgreesql.png", alt: 'Postgres Logo', label: 'Postgres' },


    ]
  },
  {
    category: 'Other languages',
    imageSrc: './card3.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'Hotel Management App',
    description: 'Developed a hotel management system that processes 200+ bookings per month, applying Java OOP principles, MVC architecture, and designing an intuitive GUI.',
    buttonLink: 'https://drive.google.com/file/d/1jOo5MWBXNRS0rhdJEEawn4mWmThNdw7O/view?usp=share_link',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/Hotel_Management_App',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=13679&format=png&color=000000', alt: 'Java Logo', label: 'Java' },
    ],
  },
  {
    category: 'UIUX',
    imageSrc: './card4.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'Designing Neuron: A medical platform',
    description: 'A medical platform focused on enhancing healthcare accessibility and efficiency. It provides intuitive UI/UX designs for seamless appointment scheduling, and medical record management. A smooth and reliable experience for both patients and healthcare professionals.',
    buttonLink: 'https://www.figma.com/design/0NWi4CR09F3swEo0SpP5th/Challenge-3?t=SYV0lt55an06re3D-0',
    buttonText: 'Figma link →',

    techIcons: [
      { src: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg', alt: 'Figma Logo', label: 'Figma' },
    ],
  },
  {
    category: 'UIUX',
    imageSrc: './card5.jpeg',
    imageClass: 'project-img-mobile-placeholder',
    title: 'Redesigning Progres app',
    description: "Enhancing the UI/UX of Algeria's student portal for improved accessibility and usability. The redesign focused on creating a modern, intuitive interface that simplifies grade tracking, schedule management, and academic services.",
    buttonLink: 'https://www.figma.com/design/dtFJIsFD9ktKJuBg08XlF8/Untitled?node-id=1-4&t=tkK39qZabiGiRxG2-1',
    buttonText: 'Figma link →',

    techIcons: [
      { src: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg', alt: 'Figma Logo', label: 'Figma' },
    ],
  },
  {
    category: 'Mobile Development',
    imageSrc: './card6.jpeg',
    imageClass: 'project-img-mobile-placeholder',
    title: 'Recipe App',
    description: 'Developed a mobile recipe app using Flutter and SQLite, enabling users to browse and save over 50 recipes, implementing state management for smooth navigation.',
    buttonLink: 'https://drive.google.com/file/d/1M6hBA0Hpd2N6RYxLtLINT8BjkIKgWW-r/view?usp=share_link',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/RecipeApp_Flutter',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=7I3BjCqe9rjG&format=png&color=000000', alt: 'Flutter Logo', label: 'Flutter' },
    ],
  },

  {
    category: 'Mobile Development',
    imageSrc: './card10.png',
    imageClass: 'project-img-mobile-placeholder',
    title: 'React Native Wallet',
    description: 'A mobile wallet application built with React Native and Expo that allows users to manage their finances, track transactions, and monitor their balance.',
    buttonLink: 'https://drive.google.com/file/d/1o-PBEOJmYXd5_C9MhG5p6bOFhFZJJl4t/view?usp=sharing',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/React-Native-Wallet-mobile-frontend?tab=readme-ov-file',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=asWSSTBrDlTW&format=png&color=000000', alt: 'ReactJS Logo', label: 'ReactJS' },
      { src: 'https://www.svgrepo.com/show/373753/light-expo.svg', alt: 'Expo Logo', label: 'Flutter' },
    ],
  },

  {
    category: 'Other languages',
    imageSrc: './card7.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'QCS Console Game',
    description: 'This project is a console-based QCM Application that provides users with the ability to log in, choose qcm categories, answer questions with a timer, and track their qcm history.',
    buttonLink: 'https://www.youtube.com/watch?v=d8t6BRGSa6A&ab_channel=Chaima',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/Python-QCM-Game',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=l75OEUJkPAk4&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
    ],
  },

  {
    category: 'AI',
    imageSrc: './card9.png',
    imageClass: 'project-img-placeholder',
    title: 'Fashion MNIST Classifier',
    description: 'A deep learning application classifies Fashion MNIST clothing images with ~91% test accuracy using a CNN built with TensorFlow and Keras, featuring convolutional layers, dropout, and maxpooling. The 70,000 images were preprocessed with NumPy and PIL. A Streamlit web interface enables real-time predictions with Plotly visualizations for confidence scores. Deployed on Hugging Face for accessibility, with performance metrics.',
    buttonLink: 'https://drive.google.com/file/d/1HKddRHyDgKauMb-6HGLnUNGKzReA2JS2/view?usp=sharing',
    buttonText: 'Check Demo →',
    githubLink: 'https://github.com/DjazzGh/Fashion-MNIST-Classifier',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=l75OEUJkPAk4&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },

    ],
  },
    {
    category: 'Cybersecurity',
    imageSrc: './card11.jpeg',
    imageClass: 'project-img-placeholder',
    title: 'Penetration Test Lab – Metasploitable2',
    description: 'Executed a full-cycle penetration test on a Linux target, leveraging Nmap, Gobuster, Nikto, and John the Ripper to identify, exploit, and document security vulnerabilities, culminating in root access and a comprehensive remediation report.',
    githubLink: 'https://github.com/DjazzGh/Pentesting',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=qBWtR72kluCU&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
{ src: 'https://img.icons8.com/?size=100&id=9b5wowKIlo9d&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
{ src: 'https://img.icons8.com/?size=100&id=PW0ChfedZvTh&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
    ],
  },
  {
    category: 'Cybersecurity',
    imageSrc: './card12.png',
    imageClass: 'project-img-placeholder',
    title: 'SSH Brute-Force Detection Lab (Wazuh SIEM)',
    description: 'Created a security monitoring lab that simulates a real-world SSH brute-force attack and demonstrates end-to-end detection, analysis, and automated response using Wazuh as the SIEM/XDR platform and Kali Linux as the attacker machine.',
    githubLink: 'https://github.com/DjazzGh/ssh-brute-force-detection-lab-wazuh',
    techIcons: [
      { src: 'https://img.icons8.com/?size=100&id=qBWtR72kluCU&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
{ src: 'https://img.icons8.com/?size=100&id=63208&format=png&color=000000', alt: 'C++ Logo', label: 'C++' },
{ src: 'https://wazuh.com/wp-content/themes/wazuh-v3/assets/images/trademark-and-brand-policy/Wazuh-logo-dark-backgroud.png', alt: 'C++ Logo', label: 'C++' },
    ],
  },

];

function Projects() {
  const [activeMainFilter, setActiveMainFilter] = useState('Development');
  const [activeSubFilter, setActiveSubFilter] = useState('Web');
  const [isLightMode, setIsLightMode] = useState(false);

  useEffect(() => {
    setIsLightMode(document.documentElement.classList.contains('light-mode'));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setIsLightMode(document.documentElement.classList.contains('light-mode'));
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  const activeCategoryFilter = activeMainFilter === 'Development'
    ? (activeSubFilter === 'Web' ? 'Web Development' : 'Mobile Development')
    : activeMainFilter;

  const filteredProjects = projectData.filter(
    (proj) => proj.category === activeCategoryFilter
  );

  return (
    <section className="projects" id="projects">
      <h2 style={{ marginBottom: '20px' }}>Projects</h2>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
        <CustomRadioButtons
          activeMainFilter={activeMainFilter}
          setActiveMainFilter={setActiveMainFilter}
          activeSubFilter={activeSubFilter}
          setActiveSubFilter={setActiveSubFilter}
          isLightMode={isLightMode}
        />
      </div>
      <div className="project-card-container" style={{ gap: '1.5rem', width: '100%' }}>
        <div
          className={`${activeCategoryFilter.replace(/\s/g, '')}-Projects`}
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '2rem',
            alignItems: 'stretch',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          {filteredProjects.length > 0 ? (
            filteredProjects.map((proj, idx) => (
              <ProjectCard
                key={proj.title + idx}
                {...proj}
                showGithubButton={proj.category !== 'UIUX'}
              />
            ))
          ) : (
            <div
              style={{
                padding: '40px 20px',
                color: isLightMode ? '#666' : 'rgba(255, 255, 255, 0.6)',
                fontSize: '16px',
                fontStyle: 'italic',
                textAlign: 'center',
                background: isLightMode ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.03)',
                borderRadius: '12px',
                border: `1px dashed ${isLightMode ? 'rgba(0, 0, 0, 0.15)' : 'rgba(255, 255, 255, 0.15)'}`,
                width: '100%',
                maxWidth: '600px',
                margin: '0 auto',
                backdropFilter: 'blur(4px)',
              }}
            >
              No projects available in this category yet. Stay tuned!
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Projects;
